import { render, staticRenderFns } from "./EditAssignedRole.vue?vue&type=template&id=0398f7c6&scoped=true&"
import script from "./EditAssignedRole.vue?vue&type=script&lang=ts&"
export * from "./EditAssignedRole.vue?vue&type=script&lang=ts&"
import style0 from "./EditAssignedRole.vue?vue&type=style&index=0&id=0398f7c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0398f7c6",
  null
  
)

export default component.exports